import { render, staticRenderFns } from "./AppDetailTab6.vue?vue&type=template&id=67c6fa19&scoped=true";
import script from "./AppDetailTab6.vue?vue&type=script&lang=js";
export * from "./AppDetailTab6.vue?vue&type=script&lang=js";
import style0 from "./AppDetailTab6.vue?vue&type=style&index=0&id=67c6fa19&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "67c6fa19", null);
export default component.exports;